<template>
    <div class="mandate-conformity-banner">
        <img src="/ressources/logged/img/illustrations/settings-warning.svg" alt="" />
        <div class="mandate-conformity-banner__content">
            <h2 class="mandate-conformity-banner__title typographies-paragraph-large-bold">
                {{ title }}
            </h2>
            <div
                class="mandate-conformity-banner__description typographies-paragraph-medium-regular"
            >
                {{ description }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        type: {
            type: String,
            required: true,
        },
    },
    computed: {
        title() {
            switch (this.type) {
                case 'company_information':
                    return this.$t.__('MandateConformityBanner.companyInformation.title');
                default:
                    return '';
            }
        },
        description() {
            switch (this.type) {
                case 'company_information':
                    return this.$t.__('MandateConformityBanner.companyInformation.description');
                default:
                    return '';
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.mandate-conformity-banner {
    align-items: center;
    background: linear-gradient(90deg, #2645c6 0%, #4868fd 75%);
    color: var(--colors-common-text-standard-on-color);
    display: flex;
    gap: var(--spacing-2);
    margin: -32px -24px var(--spacing-4);
    padding: var(--spacing-3) var(--spacing-4);

    &__title {
        margin: 0;
    }
}
</style>
